module.exports = __webpack_public_path__ + "img/ico_wxzf.f1037d69.png";